import axios from 'axios';
import Role from '@/domain/role/role.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class RoleService {
  static searchAllActiveRoles(): Promise<Role[]> {
    return axios
      .get('/project-api/roles')
      .then((response: any) => Role.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
